// Write your code here
import {AiFillClockCircle} from 'react-icons/ai'
import './index.css'

const CourseTimelineCard = props => {
  const {courseDetails} = props
  const {duration, courseTitle, description, tagsList} = courseDetails
  console.log(courseDetails)

  return (
    <div className="bg-Course">
      <div className="title-sub">
        <h1>{courseTitle}</h1>
        <div className="clock-duration">
          <AiFillClockCircle />
          <p>{duration}</p>
        </div>
      </div>
      <p>{description}</p>
      <div className="tags-container">
        {tagsList.map(eachTag => (
          <p key={eachTag.id} className="tags">
            {eachTag.name}
          </p>
        ))}
      </div>
    </div>
  )
}

export default CourseTimelineCard
